// @flow

import { type UserInputValidationError, type UserInputValidatorArgs, onlyWhenSupport, VALID } from '@tectonics/prs/validation';

import { validateMexicanPhoneNumber } from './mexican-phone-number';
import { validateMexicanZipcode } from './mexican-zipcode';
import { validateMexicanState } from './mexican-state';
import { validateMexicanCity } from './mexican-city';
import { validateMexicanAddress } from './mexican-address';
import { validateMexicanStreetNumber } from './mexican-street-number';
import { getCurrentFeatures } from '@tectonics/prs/payment-spec';
import { getCurrentPaymentMethodOptionalFields, hasOptionalField } from '@tectonics/prs/incoming-payment/get-payment-type-optional-fields';

export function validator({
  spec,
  prsSupport,
  userInputName,
  userInputValue,
  userInputValues,
  incomingPayment,
}: UserInputValidatorArgs): ?UserInputValidationError {
  const currentFeatures = getCurrentFeatures(spec, userInputValues['selectedPaymentMethod']);
  const onlyWhen = onlyWhenSupport(currentFeatures, prsSupport);
  let optionalFields = incomingPayment.status === 'OP' ? getCurrentPaymentMethodOptionalFields(incomingPayment, userInputValues, spec) : [];

  switch (userInputName) {
    case 'mexicanPhoneNumber':
      if (!hasOptionalField(optionalFields, 'telephone')) {
        return onlyWhen('field_mexican_phone_number') && validateMexicanPhoneNumber(userInputValue);
      }
      return null;

    case 'mexicanZipcode':
      if (!hasOptionalField(optionalFields, 'zipcode')) {
        return onlyWhen('field_mexican_zipcode') && validateMexicanZipcode(userInputValue);
      }
      return null;

    case 'mexicanState':
      if (!hasOptionalField(optionalFields, 'state')) {
        return onlyWhen('field_mexican_state') && validateMexicanState(userInputValue);
      }
      return null;

    case 'mexicanCity':
      if (!hasOptionalField(optionalFields, 'city')) {
        return onlyWhen('field_mexican_city') && validateMexicanCity(userInputValue);
      }
      return null;

    case 'mexicanAddress':
      if (!hasOptionalField(optionalFields, 'address')) {
        return onlyWhen('field_mexican_address') && validateMexicanAddress(userInputValue);
      }
      return null;

    case 'mexicanStreetNumber':
      if (!hasOptionalField(optionalFields, 'street_number')) {
        return onlyWhen('field_mexican_street_number') && validateMexicanStreetNumber(userInputValue);
      }
      return null;

    default:
      return VALID;
  }
}
